import { type DrawableMixin } from "../objects/drawable_mixin"
import PathObject from "../objects/path"
import Form from "./base"
import Calc from "@/common/util/calculator"
import PolygonObject from "@/signomatic/app/objects/polygon"
import { stainlessTagPath } from "@/signomatic/util/shapes"

export default class ArchedTopBottom extends Form {
  protected path(width: number, height: number) {
    if (this.drawables.production === "cut") {
      const x = -(width / 2)
      const y = -(height / 2)
      const points = []

      points.push({ x, y })
      points.push({ x: x + width, y })
      points.push({ x: x + width, y: y + height })
      points.push({ x, y: y + height })
      points.push({ x, y })

      return new PolygonObject(points, this.defaultParams)
    }

    // returns fixed size stainless_28x49 legacy tag
    return new PathObject(stainlessTagPath(width, height), this.defaultParams)
  }

  protected cutlineGappedPath(width: number, height: number): DrawableMixin | undefined {
    const styles = { stroke: "#f08894", strokeWidth: this.drawables.cutlineWidth, fill: "transparent" }

    if (["label_plates", "stainless_steel_sign"].includes(this.signType) && this.state.material === "stainless") {
      return new PathObject(this.stainlessTagCutLine(height).join(""), {
        ...this.defaultParams,
        ...styles,
      })
    }

    return
  }

  protected stainlessTagCutLine(height: number) {
    const legLength = Calc.mmToPx(2.5)
    const gap = Calc.mmToPx(0.2)
    const centerY = 0

    // values from stainlessTagPath
    const maxY = height / 2 + 0.1
    const radius = 53
    const cornerRadius = 38.5

    // from top leg to right side
    const segment1 = []
    segment1.push(this.pathMoveTo(0, -maxY - legLength))
    segment1.push(this.pathLineToAbs(0, -maxY))
    segment1.push(this.pathLineHAbs(gap / 2))
    segment1.push(this.pathLineHAbs(radius - cornerRadius))
    segment1.push(this.pathCurveAbs(radius, -maxY, radius, -maxY + cornerRadius, radius, -maxY + cornerRadius))
    segment1.push(this.pathLineVAbs(centerY - gap / 2))

    // from right leg around bottom to left side
    const segment2 = []
    segment2.push(this.pathMoveTo(radius + legLength, centerY))
    segment2.push(this.pathLineToAbs(radius, centerY))
    segment2.push(this.pathLineVAbs(centerY + gap / 2))
    segment2.push(this.pathLineVAbs(maxY - cornerRadius))
    segment2.push(this.pathCurveAbs(radius, maxY, radius - cornerRadius, maxY, radius - cornerRadius, maxY))
    segment2.push(this.pathLineHAbs(-radius + cornerRadius))
    segment2.push(this.pathCurveAbs(-radius, maxY, -radius, maxY - cornerRadius, -radius, maxY - cornerRadius))
    segment2.push(this.pathLineVAbs(centerY + gap / 2))

    // from left leg back to top
    const segment3 = []
    segment3.push(this.pathMoveTo(-radius - legLength, centerY))
    segment3.push(this.pathLineToAbs(-radius, centerY))
    segment3.push(this.pathLineVAbs(centerY - gap / 2))
    segment3.push(this.pathLineVAbs(-maxY + cornerRadius))
    segment3.push(this.pathCurveAbs(-radius, -maxY, -radius + cornerRadius, -maxY, -radius + cornerRadius, -maxY))
    segment3.push(this.pathLineHAbs(-gap / 2))

    return [segment1.join(" "), segment2.join(" "), segment3.join(" ")]
  }
}
